import './SocialLogos.scss';

import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const SocialLogos = () => {
  return (
    <div className='logo'>
      <a href="https://fr-fr.facebook.com/skinnytattoovitrolles" 
          target='_blank' 
          className="logo_facebook" 
          rel="noreferrer">
          <FacebookIcon/>
      </a>

      <a href='https://www.instagram.com/elo_skinny_tattoo/?hl=fr' 
          target='_blank' 
          className="logo_instagram" 
          rel="noreferrer">
          <InstagramIcon/>
      </a>
     
    </div>
  )
}


export default SocialLogos;